import React, { useEffect } from "react";
import type { NextPage } from "next";
import Header from "@/components/house-of-senco/header";
import Banner from "@/components/house-of-senco/banner/banner";
import Catagorie from "@/components/house-of-senco/catagories/catagorie";
import Collecttions from "@/components/house-of-senco/collecttions/collecttions";
import SennesAham from "@/components/house-of-senco/sennes-aham";
import BestSellers from "@/components/house-of-senco/bestsellers/bestsellers";
import House from "@/components/house-of-senco/house/house";
import TrendUpdates from "@/components/house-of-senco/trend_updates/trend_updates";
import Footer from "@/components/house-of-senco/footer/footer";
import { useAppDispatch } from "@/store";
import { useSelector } from "react-redux";
import { fetchAuthUser, selectAuth } from "@/store/slices/auth";
import { fetchCartItems, selectCart } from "@/store/slices/cart";
import { fetchWishlistItems, selectWishlist } from "@/store/slices/wishlist";
import { initTryOnTracking } from "@/lib/tryOnTracking";
import AuthModal from "@/components/auth/auth-modal";
import BillingAddressModal from "@/components/auth/billing-address-modal";
import OfferModal from "@/components/auth/offer-modal";
import AccountSelectionModal from "@/components/auth/sccount-selection-modal";
import CustomerConsent from "@/components/auth/customer-consent";
import { ToastContainer } from "react-toastify";
import Head from "next/head";

const HouseOfSenco: NextPage = () => {
  const dispatch = useAppDispatch();
  const authState = useSelector(selectAuth);
  const cartState = useSelector(selectCart);
  const wishlistState = useSelector(selectWishlist);

  useEffect(() => {
    initTryOnTracking();
    dispatch(fetchAuthUser()).then((data) => {
      if (data.payload) {
        dispatch(fetchWishlistItems(data.payload.id));
        initTryOnTracking(data.payload.id);
      }
    });
    dispatch(fetchCartItems());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
        <title>House of Senco</title>
      </Head>
      <Header />
      <Banner />
      {/* <Catagorie /> */}
      <Collecttions />
      <SennesAham />
      {/* <BestSellers /> */}
      <House />
      <TrendUpdates />
      <Footer />
      <AuthModal />
      <BillingAddressModal />
      {/* <OfferModal /> */}
      <AccountSelectionModal />
      <CustomerConsent />
      <ToastContainer
        autoClose={2000}
        theme={"colored"}
        newestOnTop={true}
        position="top-center"
      />
    </>
  );
};

export default HouseOfSenco;
